export const wordCloudSkillsGrid = [
  [
    { name: "Stripe", radius: 8 },
    { name: "LangChain", radius: 12 },
    { name: "Tailwind", radius: 7 },
    { name: "Zustand", radius: 7 },
    { name: "MongoDB", radius: 13 },
    { name: "RAG", radius: 6 },
    { name: "CosmosDB", radius: 8 },
    { name: "Okta", radius: 9 },
  ],
  [
    { name: "Full Stack", radius: 15 },
    { name: "SendGrid", radius: 10 },
    { name: "React", radius: 20 },
    { name: "SSO", radius: 9 },
    { name: "Agile", radius: 13 },
    { name: "Storybook", radius: 7 },
    { name: "Azure AI Search", radius: 8 },
    { name: "DevOps", radius: 10 },
  ],
  [
    { name: "Microservices", radius: 7 },
    { name: "OpenStreetMap", radius: 10 },
    { name: "Java", radius: 11 },
    { name: "MUI", radius: 14 },
    { name: "Stripe", radius: 9 },
    { name: "Next.js", radius: 13 },
    { name: "OpenAI", radius: 16 },
    { name: "Product-driven development", radius: 7 },
  ],
  [
    { name: "Docker", radius: 7 },
    { name: "Node.js", radius: 18 },
    { name: "Vercel", radius: 7 },
    { name: "Ionic", radius: 11 },
    { name: "Mapbox GL JS", radius: 12 },
    { name: "Apollo", radius: 7 },
    { name: "Azure Services", radius: 8 },
    { name: "Product Management", radius: 7 },
  ],
  [
    { name: "Backend", radius: 13 },
    { name: "CI/CD", radius: 8 },
    { name: "NestJS", radius: 17 },
    { name: "GeoJSON", radius: 10 },
    { name: "Redux", radius: 7 },
    { name: "Kotlin", radius: 12 },
    { name: "LLMs", radius: 9 },
    { name: "FastAPI", radius: 11 },
  ],
  [
    { name: "React Native", radius: 14 },
    { name: "TypeScript", radius: 20 },
    { name: "Team Collaboration", radius: 8 },
    { name: "Agile", radius: 7 },
    { name: "Prompt Engineering", radius: 12 },
    { name: "Travel & Transportation", radius: 9 },
    { name: "Jest", radius: 8 },
    { name: "Figma", radius: 7 },
  ],
  [
    { name: "GraphQL", radius: 17 },
    { name: "Shopify", radius: 10 },
    { name: "Android", radius: 13 },
    { name: "LlamaIndex", radius: 14 },
    { name: "Gen AI", radius: 15 },
    { name: "Azure OpenAI", radius: 14 },
    { name: "UI/UX", radius: 11 },
    { name: "Gitlab", radius: 10 },
  ],
  [
    { name: "Kotlin", radius: 8 },
    { name: "Agentic Gen AI", radius: 8 },
    { name: "Python", radius: 9 },
    { name: "Frontend", radius: 13 },
    { name: "AWS", radius: 9 },
    { name: "Data Governance", radius: 8 },
    { name: "Nx", radius: 11 },
    { name: "Firebase", radius: 7 },
  ],
];

export const experiences = [
  {
    company: "IBM Consulting",
    period: "July 2022 — Present",
    image: "images/ibm-logo.png",
    items: [
      {
        title: "Engineering Lead",
        subcompany: "Boston Consulting Group",
        url: "https://www.bcg.com/",
        description:
          "Led technical direction for the Gen AI Growth Diagnostic project, transforming manual strategy development into an AI-powered interactive platform. Designed scalable Next.js and MongoDB architecture, implemented authentication with Okta, and integrated generative AI using OpenAI and LangChain.",
        technologies: [
          "Next.js",
          "Typescript",
          "MongoDB Atlas",
          "Okta",
          "OpenAI",
          "LangChain",
          "Vercel",
        ],
      },
      {
        title: "Engineering Lead",
        subcompany: "Pizza Hut",
        url: "https://www.yum.com/wps/portal/yumbrands/Yumbrands/company/our-brands/pizza-hut",
        description:
          "Architected and delivered the Pizza Hut Medic Assistant, a React Native app using generative AI to triage technical issues. Integrated with ServiceNow, Azure OpenAI, and deployed infrastructure on Azure while serving as the primary engineering contact for stakeholders.",
        technologies: [
          "React Native",
          "Typescript",
          "Azure",
          "ServiceNow",
          "Azure OpenAI",
          "LlamaIndex",
        ],
      },
      {
        title: "Senior Full Stack Engineer",
        subcompany: "Link Logistics",
        url: "https://www.linklogistics.com/",
        description:
          "Led frontend technical design and contributed full-stack to Property IQ, a Mapbox-based application used internally to manage property data. Implemented advanced geospatial features, optimized performance, and collaborated closely with stakeholders and junior devs.",
        technologies: [
          "React",
          "Typescript",
          "Node.js",
          "Azure",
          "Mapbox",
          "OpenStreetMap",
        ],
      },
    ],
  },
  {
    company: "Kara & Nate",
    period: "Feb 2021 — Jul 2022",
    image: "images/kara-and-nate-logo.png",
    items: [
      {
        title: "Senior Full Stack Engineer / Product Manager",
        subcompany: "Faredrop",
        url: "https://faredrop.com/",
        description:
          "Spearheaded the launch of a mobile app and revamped the web UX using React, Ionic, and TypeScript. This resulted in a 385% increase in MRR and an 874% surge in new subscribers. Developed the Deal Scoring algorithm to intelligently prioritize Google Flights deals, streamlining operations and improving personalization.",
        technologies: [
          "React",
          "Ionic",
          "TypeScript",
          "Node.js",
          "AWS",
          "GraphQL",
          "SendGrid",
          "Stripe",
        ],
      },
      {
        title: "Senior Full Stack Engineer / Product Manager",
        subcompany: "atlas.co",
        url: "https://www.youtube.com/watch?v=Vi7PRkAfzq4",
        description:
          "Led a full site-wide frontend redesign using Vue.js and TypeScript, improving usability and reducing customer support tickets by 68% year-over-year during peak season. Engineered backend infrastructure for expanded map product options, integrating with the Shopify GraphQL Bulk API and enabling over $50K in seasonal sales.",
        technologies: ["Vue.js", "TypeScript", "Node.js", "Shopify", "AWS"],
      },
    ],
  },
  {
    period: "Aug 2019 — Feb 2021",
    company: "Vrbo",
    image: "images/vrbo-logo.png",
    items: [
      {
        title: "Android Engineer",
        url: "https://www.vrbo.com/",
        description:
          "Built core features for the Android Traveler app, including a map-paint search tool that generated $1M+ in revenue. Led Kotlin migration and created social features for group travel planning and polling.",
        technologies: ["Kotlin", "Java", "OpenGL", "GraphQL"],
      },
    ],
  },
  {
    period: "Aug 2014 — May 2019",
    company: "The University of Texas at Austin",
    image: "images/texas-logo.svg",
    items: [
      {
        title: "Graduate / Undergraduate Student",
        url: "https://www.utexas.edu/",
        description: "M.S. of Information Studies / B.S. of Computer Science",
      },
    ],
  },
];
